import styled,{ keyframes } from 'styled-components';
import { MdKeyboardArrowRight, MdArrowForward } from 'react-icons/md';

const anim2 = keyframes`
    from{
            left: -100%;
        }
        to{
            left:0%;
        }
`;

const animateWave = keyframes`
    0% {
      transform: scale(1,0);
    }
    100% {
      transform: scale(1,1);
    }
`

export const LandingContainer = styled.div`
    justify-content: center;
    align-items: center;
    height: 100vh;
    position: relative;
    z-index: 1;

    :before{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        
        z-index: 2;

    }

     @media screen and (max-width: 991px){
        width: ${({isLandscape}) => (isLandscape ? '132vw' : '100%')};
        height: ${({fixLandscape}) => (fixLandscape ? '100vw;' : '100vh')};
     }

    @media screen and (max-width: 480px){
            height: 105vh;
    }
` 

export const WaveContainer = styled.div`
    position: relative;
    //background: rgba(0,0,0,0.3);
   // background: linear-gradient(to right, rgba(38,61,250,1) 0%, rgba(54,104,244,1) 14%, rgba(70,153,236,1) 35%, rgba(83,188,232,1) 56%, rgba(83,200,236,1) 77%, rgba(78,235,248,1) 100%);
    color: white;
    text-align: center;
    overflow: hidden;
    height: 800px;
    @media screen and (max-width: 1366px){
        height: 625px;
    }
    
    @media screen and (max-width: 480px){
        height: 100vh;
    }
`
export const Wave = styled.svg`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    animation: ${anim2} 2s forwards 0s;
    
    @media screen and (max-width: 480px){
        bottom: 0;
    }

`
export const LandingContentWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: ${anim2} 2s forwards 0s;
    justify-content: center;
    height: 370px;
    
`

export const LandingContent = styled.div`
    padding-top: 140px;
    padding-left: 20px;
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    max-width: 1020px;
    margin: 0 auto;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    animation: ${anim2} 2s forwards 0s;

    @media screen and (max-width: 480px){
        padding-left: 20px;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        display: flex;
        max-width: 1020px;
        margin: 0 auto;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        animation: ${anim2} 2s forwards 0s;
        height: 100vh;
    }

`   

export const LandingBg = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
`

export const VideoBg = styled.video`
    width: 100%;
    height: 800px;
    -o-object-fit: cover;
    object-fit: cover;
    object-position: bottom;
    background: #232a34;
    @media screen and (max-width: 1366px){
        height: 625px;
    }
    
    @media screen and (max-width: 480px){
        height: 100vh;
    }
    
`

export const LandingH1 = styled.h1`
    font-size: 36px;
    max-width: 440px;
    color: #FFF;
    text-align: left;
    font-weight: 700;
    font-family: 'Roboto-regular', sans-serif;     
    margin-top: 255px;
    margin-bottom: 40px;

   
    @media screen and (max-width: 480px){
        margin-top: 100px;
        font-size: 30px;
        text-align: center;
    }

`


export const LandingP = styled.p`
    margin-top: 0px;
    font-size: .75em;
    max-width: 320px;
    font-weight: 450;
    color: #FFF;
    text-align: left;
    font-family: 'Barlow Condensed', sans-serif;     
    margin-bottom: 20px;
    @media screen and (max-width: 480px){
        display: none;
    }
    
`

export const LandingP2 = styled.p`
    display: none;
    margin-top: 15px;
    color: #fff;
    font-size: 24px;
    max-width: 600px;
    text-shadow: 1px 1px 1px #000;


    @media screen and (max-width: 768px){
        text-align: center;
        display: flex;
        font-size: 24px;
    }
    @media screen and (max-width: 480px){
        font-size: 18px;
    }
`

export const LandingBtnWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-top: 0px;
    padding-left: 0px;
    z-index: 999;
    
    @media screen and (max-width: 480px){
        margin-top: 50px;
        padding-left: 0;
        justify-content: center;
        width: 100%;
    }
`

export const ArrowFoward = styled(MdArrowForward)`
    margin-left: 8px;
    font-size: 20px;
`

export const ArrowRight = styled(MdKeyboardArrowRight)`
    margin-left: 8px;
    font-size: 20px;
`